import React from 'react';

const Title = ({ children }) => {
  return (
    <div>
      <div className='col-auto mt-3'>
        <h3 className='font-weight-bolder'>{children}</h3>
      </div>
    </div>
  );
};

export default Title;
